import React, { Fragment, useState } from "react";
import Layout from "../../layouts/Layout";
import { useTranslation } from "react-i18next";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import { formatFbError, types } from "../../services/formatFbError";
import { Form, Input, notification } from "antd";
import { WEBSITE_NAME } from "../../constants/CompanyConstants";
import {
  META_RESET_PASSWORD_DESCRIPTION,
  META_RESET_PASSWORD_TITLE,
} from "../../constants/MetaTagsConstants";
import { Helmet } from "react-helmet";
import AntdCtaBtn from "../../components/cta/AntdCtaBtn";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../services/firebase";

const LoginRegister = () => {
  const [form] = Form.useForm();
  const [resetEmailInputError, setResetEmailInputError] = useState(null);
  const { t } = useTranslation();

  const handleResetPassword = () => {
    form.validateFields().then((values) => {
      sendPasswordResetEmail(auth, values.email)
        .then(() => {
          notification["success"]({
            message: t("notifications.reset_email_sent"),
          });
          form.resetFields();
        })
        .catch((error) => {
          let errorMessage = formatFbError(error.code);
          if (errorMessage.type === types.email) {
            setResetEmailInputError(errorMessage.text);
          } else
            notification["warning"]({
              message: errorMessage.text,
            });
        });
    });
  };

  return (
    <Fragment>
      <Helmet>
        <title>
          {META_RESET_PASSWORD_TITLE} · {WEBSITE_NAME}
        </title>
        <meta name="description" content={META_RESET_PASSWORD_DESCRIPTION} />
      </Helmet>
      <Layout headerTop="visible">
        <div className="section-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-12 ml-auto mr-auto">
                <div className="login-register-wrapper">
                  <Tab.Container defaultActiveKey="reset-password">
                    <Nav variant="pills" className="login-register-tab-list">
                      <Nav.Item>
                        <Nav.Link eventKey="reset-password">
                          <h4>{t("reset_password")}</h4>
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content>
                      <Tab.Pane eventKey="reset-password">
                        <div className="login-form-container">
                          <Form
                            layout="vertical"
                            name="reset-password-form"
                            onFinish={handleResetPassword}
                            form={form}
                          >
                            <Form.Item
                              name="email"
                              label={t("email")}
                              rules={[
                                {
                                  required: true,
                                  message: t("form.enter_email"),
                                },
                                {
                                  type: "email",
                                  message: t("form.enter_valid_email"),
                                },
                              ]}
                              hasFeedback={!!resetEmailInputError}
                              help={resetEmailInputError}
                            >
                              <Input size={"large"} />
                            </Form.Item>
                            <Form.Item className="mt-2">
                              <AntdCtaBtn
                                type="primary"
                                htmlType="submit"
                                block
                                size={"large"}
                              >
                                <span>{t("reset")}</span>
                              </AntdCtaBtn>
                            </Form.Item>
                          </Form>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </Fragment>
  );
};

export default LoginRegister;
